import { action } from 'satcheljs';
import type { PartialTheme } from '@fluentui/theme';
import type { DensityMode } from '../store/schema/ExtendedTheme';

export interface MUTATE_FABRIC_DENSITYActionMessage {
    densityMode: DensityMode;
    density: PartialTheme;
}
const defaultExport: (
    densityMode: DensityMode,
    density: PartialTheme
) => MUTATE_FABRIC_DENSITYActionMessage = action(
    'MUTATE_FABRIC_DENSITY',
    (densityMode: DensityMode, density: PartialTheme): MUTATE_FABRIC_DENSITYActionMessage => ({
        densityMode,
        density,
    })
);
export default defaultExport;
